// interfaces
import React, { FC } from 'react';
import { BrowserRouter as Router } from 'react-router-dom';
// components
import { Box, Container, Fab, makeStyles } from '@material-ui/core';
import { KeyboardArrowUp } from '@material-ui/icons';

import { Header } from './Header';
import { ScrollTop } from './ScrollTop';

const useStyles = makeStyles({
  main: {
    margin: '15px 0 100px 0',
  },
});

export const Layout: FC = ({ children }) => {
  const cls = useStyles();

  return (
    <>
      <Router>
        <Header />
        <Box className={cls.main}>
          <Container maxWidth="md">
            <Box>{children}</Box>
          </Container>
        </Box>
      </Router>
      <ScrollTop>
        <Fab color="secondary" size="small" aria-label="scroll back to top">
          <KeyboardArrowUp />
        </Fab>
      </ScrollTop>
    </>
  );
};
